import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  customerRecords: [],
  customerLocationRecords: [],
  locationSearchCache: {},
  // serviceContractList: [], // TODO: re-enable service contract
  CustomerprojectRecords: [],
  customerDefaultProject: [],
  serviceItemsList: [],
  modalLoading: false,
};
const CreateAppointmentSlice = createSlice({
  name: "CreateAppointment",
  initialState,
  reducers: {
    getCustomerListRecords: (state, action) => {
      state.customerRecords = action.payload;
    },
    getCustomerLocationRecords: (state, action) => {
      state.customerLocationRecords = action.payload;
    },
    setLocationSearchCache: (state, action) => {
      const { term, results } = action.payload;
      state.locationSearchCache[term] = results;
      state.customerLocationRecords = results;
    },
    // getServiceContractRecords: (state, action) => { // TODO: re-enable service contract
    //   state.serviceContractList = action.payload;
    // },
    getProjectRecords: (state, action) => {
      state.CustomerprojectRecords = action.payload;
    },
    getDefaultProjectRecords: (state, action) => {
      state.customerDefaultProject = action.payload;
    },
    getServiceItemRecords: (state, action) => {
      state.serviceItemsList = action.payload;
    },
    showModalLoader(state) {
      state.modalLoading = true;
    },
    hideModalLoader(state) {
      state.modalLoading = false;
    },
    resetState(state) {
      state.customerRecords = [];
      state.customerLocationRecords = [];
      state.locationSearchCache = {};
      // state.serviceContractList = []; // TODO: re-enable service contract
      state.CustomerprojectRecords = [];
      state.customerDefaultProject = [];
      state.serviceItemsList = [];
      state.modalLoading = false;
    },
  },
});
export const {
  getCustomerListRecords,
  getCustomerLocationRecords,
  setLocationSearchCache,
  // getServiceContractRecords, // TODO: re-enable service contract
  getProjectRecords,
  getDefaultProjectRecords,
  getServiceItemRecords,
  showModalLoader,
  hideModalLoader,
  resetState,
} = CreateAppointmentSlice.actions;
export default CreateAppointmentSlice.reducer;
